import {Component, Input, OnInit} from '@angular/core';
import {ApexOptions} from "ng-apexcharts";
import {numberWithCommas} from "../../BATCH_COLORS";

@Component({
    selector: 'app-val-premoney-day-area-chart',
    templateUrl: './val-premoney-day-area-chart.component.html',
    styleUrls: ['./val-premoney-day-area-chart.component.scss']
})
export class ValPremoneyDayAreaChartComponent implements OnInit {
    private _appForPremoney: any;
    get appForPremoney() {
        return this._appForPremoney;
    }

    @Input() set appForPremoney(val: any) {
        this._appForPremoney = val;
        if (val) {
            this.premoneyAvgforDayData = {
                chart: {
                    animations: {
                        enabled: true
                    },
                    fontFamily: 'inherit',
                    foreColor: 'inherit',
                    height: '100%',
                    type: 'area',
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: false
                    }
                },
                // colors: ['#64748B'],
                colors: ["#00E396"],
                dataLabels: {
                    enabled: false
                },
                fill: {
                    // colors: ['#64748B'],
                    type: "gradient",
                    gradient: {
                        opacityFrom: 0.4,
                        opacityTo: 0.8
                    }
                },
                grid: {
                    show: false,
                },
                legend: {
                    show: false
                },
                series: this.appForPremoney && this.appForPremoney.avgVal ?
                    this.appForPremoney.avgVal.series : [],
                stroke: {
                    curve: 'smooth',
                    width: 2
                },
                tooltip: {
                    // followCursor: true,
                    theme: 'dark',
                    x: {
                        format: 'dd MMM'
                    }
                },
                xaxis: {
                    axisBorder: {
                        show: false
                    },
                    labels: {
                        // offsetY: -20,
                        // rotate: 0,
                        style: {
                            colors: 'var(--fuse-text-secondary)'
                        },
                        format: 'dd MMM'
                    },
                    // tickAmount: 3,
                    tooltip: {
                        enabled: false
                    },
                    type: 'datetime'
                },
                yaxis: {
                    labels: {
                        style: {
                            colors: 'var(--fuse-text-secondary)'
                        },
                        formatter: (value) => {
                            return `${numberWithCommas(value)}`;
                        },
                    },
                    // max       : (max): number => max + 250,
                    // min       : (min): number => min - 250,
                    // show      : false,
                    // tickAmount: 5
                }
            };

        }
    }

    premoneyAvgforDayData: ApexOptions;

    constructor() {
    }

    ngOnInit(): void {

    }

}
